export default __webpack_public_path__ + "e8b8687a460539129b537dffbfc72205.png";